<template>
  <div class="progress five-card-hand-bar">
    <div
      class="progress-bar outer-bar"
      v-bind:class="{
        'progress-bar-success': type === 'draws',
        'progress-bar-combo': type === 'combos',
      }"
      v-bind:style="'width: ' + width * percentageOfSpecificHandsThatAreSelectedAsDecimal + 'px'"
    >
      <span v-if="probability >= 20 && percentagesOrCombos === 'percentages' && percentageOfSpecificHandsThatAreSelected > 35" class="probability">{{ probability }}%</span>
      <span v-if="probability >= 15 && percentagesOrCombos === 'combos' && percentageOfSpecificHandsThatAreSelected > 35" class="num-combos">{{ numCombos }}</span>
    </div>
    <div
      class="progress-bar progress-bar-empty inner-bar"
      v-bind:style="'width: ' + width * (1 - percentageOfSpecificHandsThatAreSelectedAsDecimal) + 'px'"
    >
      <span v-if="probability >= 20 && percentagesOrCombos === 'percentages' && percentageOfSpecificHandsThatAreSelected <= 35" class="probability">{{ probability }}%</span>
      <span v-if="probability >= 15 && percentagesOrCombos === 'combos' && percentageOfSpecificHandsThatAreSelected <= 35" class="num-combos">{{ numCombos }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'five-card-hand-bar',
  props: ['type', 'probability', 'numCombos', 'percentagesOrCombos', 'percentageOfSpecificHandsThatAreSelected'],
  computed: {
    width: function () {
      let screenWidth = (window.innerWidth > 0) ? window.innerWidth : screen.width;

      if (screenWidth >= 1200 && screenWidth <= 1340) {
        if (this.probability > 40) {
          return 50;
        }

        return Math.min(this.probability * 1.5, 50);
      }

      else if (screenWidth < 767) {
        return Math.min(this.probability * 3.5, 280);
      }

      else {
        if (this.probability > 40) {
          return 85;
        }

        return Math.min(this.probability * 1.75, 85);
      }
    },
    percentageOfSpecificHandsThatAreSelectedAsDecimal: function () {
      return this.percentageOfSpecificHandsThatAreSelected / 100;
    },
  },
};
</script>

<style lang="scss" scoped>
  .progress {
    display: inline-block;
    height: 15px;
    margin-bottom: 0px;

    .probability, .num-combos {
      position: relative;
      bottom: 1px;
    }

    .progress-bar {
      font-size: 10px;
      display: inline-block;

    }

    .progress-bar-empty {
      background-color: lightgray;

      .probability, .num-combos {
        // color: black;
      }
    }

    .progress-bar-combo {
      background-color: #9b59b6;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/five-card-hands-section/five-card-hand-bar.vue